import ValoresRepository from "@/services/ValoresRepository";

export default {
  namespaced: true,
  state: {
    listaUnidadesMedida: [],
    listaProductoAgricultor: [],
    listaProductoCultivo: [],
    listaProductoSenave: [],
    importProducto: null,
  },
  getters: {
    getProductoAgricultor: (state) => (idProducto) => {
      return state.listaProductoAgricultor.find(
        (producto) => producto.idProductoAgricultor === idProducto
      );
    },

    getProductoSenave: (state) => (idProductoSenave) => {
      return state.listaProductoSenave.find(
        (producto) => producto.idProductoSenave === idProductoSenave
      );
    },
  },
  mutations: {
    setListaProductoAgricultor(state, listaProducto) {
      state.listaProductoAgricultor = listaProducto;
    },
    setListaProductoCultivo(state, listaProducto) {
      state.listaProductoCultivo = listaProducto;
    },
    setListaProductoSenave(state, listaProductoSenave) {
      state.listaProductoSenave = listaProductoSenave;
    },
    setListaUnidadesMedida(state, listaUnidadesMedida) {
      state.listaUnidadesMedida = listaUnidadesMedida;
    },
    setImportProduct(state, producto) {
      state.importProducto = producto;
    },
    clearListaProductoAgricultor(state) {
      state.listaProductoAgricultor = [];
    },
    clearImportProduct(state) {
      state.importProducto = null;
    },
    clearListaProductosCultivo(state) {
      state.listaProductoCultivo = [];
    },
    clearListaUnidadesMedida(state) {
      state.listaUnidadesMedida = [];
    },
  },
  actions: {
    async fetchListaProductoAgricultor({ state, commit, rootState }) {
      let idAgricultor = rootState.agricultor.agricultor.idAgricultor;
      if (
        state.listaProductoAgricultor &&
        state.listaProductoAgricultor.length > 0
      ) {
        return;
      }

      let listaProducto =
        (await ValoresRepository.listaProductoAgricultor(idAgricultor)) || [];
      commit("setListaProductoAgricultor", listaProducto);
    },

    async fetchListaProductoCultivo({ state, commit }) {
      if (state.listaProductoCultivo && state.listaProductoCultivo.length > 0) {
        return;
      }

      let listaProducto =
        (await ValoresRepository.listaProductosCultivo()) || [];
      commit("setListaProductoCultivo", listaProducto);
    },

    async fetchListaProductoSenave({ state, commit }) {
      if (state.listaProductoSenave && state.listaProductoSenave.length > 0) {
        return;
      }

      let listaProductoSenave =
        (await ValoresRepository.listaProductosSenave()) || [];
      commit("setListaProductoSenave", listaProductoSenave);
    },

    async fetchListaUnidadesMedida({ state, commit }) {
      if (state.listaUnidadesMedida && state.listaUnidadesMedida.length > 0) {
        return;
      }
      let listaUnidadesMedida =
        (await ValoresRepository.listaUnidadMedida()) || [];
      commit("setListaUnidadesMedida", listaUnidadesMedida);
    },

    setImportProducto({ commit }, [producto]) {
      commit("setImportProduct", producto);
    },

    clearListaProductoAgricultor({ commit }) {
      commit("clearListaProductoAgricultor");
    },

    clearImportProducto({ commit }) {
      commit("clearImportProduct");
    },

    async clearListaProductosCultivo({ commit }) {
      commit("clearListaProductosCultivo");
    },

    async clearListaUnidadesMedida({ commit }) {
      commit("clearListaUnidadesMedida");
    },

  },
};
